<template>
  <div class="schema-form-color flex items-center">
    <a-tooltip placement="left" :title="t('propsEditor.colorPickingTool')">
      <ColorStraw class="mr-2" @ok="onStrawChange"></ColorStraw>
    </a-tooltip>
    <div class="schema-form-color-picker"></div>
    <span class="gray-9 ml-1">{{ field.value === -1 ? t('propsEditor.multiColors') : '' }}</span>
  </div>
</template>
<script setup>
// 文档：https://github.com/Simonwep/pickr#readme
import { props } from './helper';
import { onMounted, onBeforeUnmount, ref } from 'vue';
import Pickr from '@simonwep/pickr';
import ColorStraw from '@/components/ColorStraw/Index.vue';
import '@simonwep/pickr/dist/themes/classic.min.css';
import i18n from '@/locales/i18n';

const { t } = i18n.global;
const $props = defineProps({ ...props });
let pickr = null;
// 写个奇怪的值，降低用户取到相同值的概率，因为取到相同值不会触发change事件
onMounted(() => {
  console.log('mounted', $props.field.value);
  // Simple example, see optional options for more configuration.

  const defaultColor =
    $props.field.value === -1 ? 'transparent' : !$props.field.value ? 'transparent' : $props.field.value;
  // console.log(111, defaultColor)
  pickr = Pickr.create({
    el: '.schema-form-color-picker',
    theme: 'classic', // or 'monolith', or 'nano'
    swatches: [
      'rgba(0, 0, 0, 1)',
      'rgba(255, 255, 255, 1)',
      'rgba(255, 0, 0, 1)',
      'rgba(0, 255, 0, 1)',
      'rgba(0, 0, 255, 1)',
      'rgba(255, 255, 0, 1)',
      'rgba(0, 255, 255, 1)',
      'rgba(255, 0, 255, 1)',
      'rgba(0, 150, 136, 1)',
      'rgba(76, 175, 80, 1)',
      'rgba(139, 195, 74, 1)',
      'rgba(205, 220, 57, 1)',
      'rgba(255, 235, 59, 1)',
      'rgba(255, 193, 7, 1)',
    ],
    default: defaultColor,
    components: {
      preview: true,
      opacity: true,
      hue: false,
      interaction: {
        hex: false,
        rgba: false,
        hsla: false,
        hsva: false,
        cmyk: false,
        input: true,
        save: false,
        clear: true,
      },
    },
    i18n: {
      'btn:save': t('common.save'),
      'btn:cancel': t('common.cancel'),
      'btn:clear': t('common.clear'),
    },
  });
  pickr.on('change', color => {
    pickr.applyColor();
    $props.handleChange(color.toRGBA().toString());
  });
  pickr.on('clear', () => {
    pickr.setColor('transparent');
    $props.handleChange('transparent');
  });
});

const onStrawChange = value => {
  if (value) {
    console.log('onStrawChange', value);
    pickr.setColor(value);
  }
};

onBeforeUnmount(() => {
  pickr && pickr.destroyAndRemove();
});
</script>
<style lang="less" scoped>
.straw-wrap {
  position: relative;
}
.straw {
  position: absolute;
  left: 50%;
  top: 50%;
  font-size: 28px;
  transform: translate(-50%, -50%);
  pointer-events: none;
  opacity: 0.8;
}
.straw-input {
  width: 20px;
  opacity: 0;
  cursor: pointer;
}
</style>
<style lang="less">
button.pcr-button::after {
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 2px;
}
.pcr-app {
  .pcr-swatches button::after {
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 2px;
  }
}
</style>
